import { useRouter } from 'next/router'
import { createContext, useContext, useMemo } from 'react'
import type { ReactNode } from 'react'

import { Language, SupportedMarketKey } from '@nxt-insurance/constants'
import { IntlFormatter } from '@nxt-insurance/formatting'

import { getLocaleParts } from '@/utils/locale'

type Props = {
  children: ReactNode
}

const FormattingContext = createContext(
  new IntlFormatter({
    getCurrentMarket: () => SupportedMarketKey.De,
    getCurrentLanguage: () => Language.En,
  })
)

export const FormattingProvider = (props: Props) => {
  const { locale } = useRouter()
  const formatter = useMemo(() => {
    const [lang, market] = getLocaleParts(locale ?? 'en-de')
    return new IntlFormatter({
      getCurrentMarket: () => market,
      getCurrentLanguage: () => lang,
    })
  }, [locale])

  return <FormattingContext.Provider value={formatter}>{props.children}</FormattingContext.Provider>
}

export const useFormatting = () => {
  const context = useContext(FormattingContext)
  if (context === undefined) {
    throw new Error('useFormatting must be used within a FormattingProvider')
  }
  return context
}
